export default "__VITE_ASSET__bS7nvjTw__"